import { RadioGroup } from '@headlessui/react'
import RadioDot from 'components/common/RadioDot'
import { isAbsent, isPresent } from 'lib/utils'
import { FC, useCallback, useEffect, useState } from 'react'
import { IProductVariations } from './types'

interface IProductVariationsProps {
  variations?: IProductVariations
  tagLabels: {
    [name: string]: string
  }
  onVariationChange: (id: number) => void
}

const ProductVariations: FC<IProductVariationsProps> = ({
  variations,
  tagLabels,
  onVariationChange,
}) => {
  const mappedVariations = isPresent(variations)
    ? Object.entries(variations)
        .filter(([_, variation]) => variation.additional.published)
        .map(([key, variation]) => ({
          id: +key,
          price: variation.additional.price,
          weight: variation.additional.weight,
          count: variation.additional.count,
          attributes: variation.attributes,
        }))
        .sort((a, b) => a.count - b.count)
    : undefined

  const defaultVariation = isPresent(mappedVariations)
    ? mappedVariations[0]
    : undefined

  const [selectedVariation, setSelectedVariation] = useState(-1)

  useEffect(() => {
    if (isPresent(defaultVariation)) {
      setSelectedVariation(defaultVariation.id)
      onVariationChange(defaultVariation.id)
    }
  }, [])

  const handleChangeOption = useCallback(
    (value) => {
      setSelectedVariation(value)
      onVariationChange(value)
    },
    [onVariationChange]
  )

  if (isAbsent(mappedVariations)) return null

  return (
    <div>
      <p className='text-sm font-bold leading-6'>Опции:</p>

      <RadioGroup
        className='w-full mb-2'
        value={selectedVariation}
        onChange={handleChangeOption}
      >
        {mappedVariations.map((v) => {
          const attribute = Object.values(v.attributes)[0] as string
          const tag = tagLabels[attribute]
          return (
            <div className='flex items-center gap-1 py-2' key={v.id}>
              <RadioGroup.Option value={v.id}>
                {({ checked }) => <RadioDot selected={checked} />}
              </RadioGroup.Option>
              <RadioGroup.Label
                as='div'
                className='grow-0 flex flex-col items-start tracking-tight text-dark leading-snug'
              >
                <span className='text-black'>{tag}</span>
              </RadioGroup.Label>
            </div>
          )
        })}
      </RadioGroup>
    </div>
  )
}

export default ProductVariations
